// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner--a2uqe","small":"small--a2uqe","centered":"centered--a2uqe"};